import {observer} from "mobx-react";
import {fmsShippingClientOptionsStore, fmsShippingConfigStore, validationStore} from "../../../store";
import {ShippingConfigConstruct} from "../../../api";
import {ShippingConfigurationTabs} from "../../ui";

const FmsShippingConfigurationTab = observer(function FmsShippingConfigurationTab() {
    return <>
        <ShippingConfigurationTabs
            disabled={fmsShippingConfigStore.saving || fmsShippingConfigStore.loading}
            clientOptions={fmsShippingClientOptionsStore.selectOptions}
            value={fmsShippingConfigStore.value}
            onChange={(value: ShippingConfigConstruct) => {
                fmsShippingConfigStore.value = value
            }}
            onBlur={() => fmsShippingConfigStore.validate()}
            validationFor={(k) => validationStore.getFor(k)}
        />
    </>
})

export {
    FmsShippingConfigurationTab
}
